import React from 'react';
import toNumber from 'lodash/toNumber';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { Invoice, Maybe, InvoiceBillAndShipTo } from '@css-xp/graphtypes/src/generated-types-new';
import { InvoiceWidgetItem, CommonWidgetItem } from '../../widget';
import OverdueInvoiceIcon from '../../widget/src/assets/overdue-invoice-icon.svg';

type Invoices =
  | Maybe<
      Array<
        Maybe<
          Pick<
            Invoice,
            'id' | 'transactionAccountId' | 'invoiceNumber' | 'dueDate' | 'paymentCurrency' | 'total' | 'appliedBalance'
          > & {
            shipTo?: Maybe<Pick<InvoiceBillAndShipTo, 'fullName'>>;
          }
        >
      >
    >
  | undefined;

export const getOverdueInvoicesWidgetContent = (invoices: Invoices, heading?: string, version?: number) => {
  if (!invoices || !invoices.length) {
    return null;
  }

  return invoices.map((invoice, index) => {
    if (!invoice || !invoice.transactionAccountId || !invoice.invoiceNumber) {
      return null;
    }
    const URL = getRouteUrl(routePaths.invoiceDetails, {
      txaId: invoice.transactionAccountId,
      invoiceId: invoice.invoiceNumber,
    });

    if (version === 2) {
      return (
        <CommonWidgetItem
          url={URL}
          key={index}
          heading={heading}
          icon={OverdueInvoiceIcon}
          dueDate={invoice.dueDate}
          currency={invoice.paymentCurrency as string}
          total={toNumber(invoice?.total) + (invoice?.appliedBalance ?? 0)} // total: Logic same as in invoice details page
          leftText={invoice.invoiceNumber}
          company={invoice.shipTo?.fullName}
        />
      );
    }

    return (
      <InvoiceWidgetItem
        invoiceNumber={invoice.invoiceNumber}
        timestamp={invoice.dueDate}
        timestampPrefix={
          <>
            <WarningIcon label="warning" size="small" /> Due
          </>
        }
        belowDayTimestampContent={
          <>
            <WarningIcon label="warning" size="small" /> Overdue
          </>
        }
        company={invoice.shipTo?.fullName}
        url={URL}
        key={index}
        timestampClassName="warning"
        testId={`overdue-invoices-item-${index}`}
        heading={heading}
      />
    );
  });
};
